export const API_DOMAIN = {
  dev: 'https://qa-ual.shuyun.com',
  qa: 'https://qa-ual.shuyun.com',
  production: '//ual.shuyun.com'
}

export const API_PREFIX = {
  CUSTOMER: '/pcrm-customer/1.0',
  USER: '/pcrm-account/1.0',
  WEB: '/pcrm-web/1.0'
};

export enum DataSource {
  CUSTOMER = 'CUSTOMER',
  CHAT = 'CHAT'
}

export const minPageWidth = 325;

export const smallSizeWidth = 450;

export const defaultAvatarUrls = {
  [DataSource.CUSTOMER]: 'https://brand-guide.shuyun.com/IAM/2190abf1e9d3.svg',
  [DataSource.CHAT]: 'https://brand-guide.shuyun.com/IAM/30dd0936cfd2.png',
}

export const defaultAvatarUrl = defaultAvatarUrls[DataSource.CUSTOMER];
